import { apiSlice } from "./apiSlice";
import { apiRoutes } from "../../config/api";
import CryptoJS from "crypto-js";

const AUTH_ENCRYPTION_KEY =
    import.meta.env.VITE_SECRET_KEY ??
    import.meta.env.VITE_AUTH_ENCRYPTION_KEY ??
    "";

const encryptPassword = (password: string) => {
    if (!AUTH_ENCRYPTION_KEY) return password;
    // Keep encryption format aligned with legacy /login contract.
    return CryptoJS.AES.encrypt(password, AUTH_ENCRYPTION_KEY).toString();
};

const withEncryptedPassword = (credentials: any) => {
    const body = { ...(credentials ?? {}) };
    if (typeof body.password === "string" && body.password.length > 0) {
        body.password = encryptPassword(body.password);
    }
    return body;
};

export const authApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        login: builder.mutation({
            query: (credentials: any) => ({
                url: `${apiRoutes.LOGIN}`,
                method: 'POST',
                body: withEncryptedPassword(credentials),
            })
        }),
        reportsLogin: builder.mutation({
            query: (credentials: any) => ({
                url: `${apiRoutes.REPORTS_LOGIN}`,
                method: "POST",
                body: withEncryptedPassword(credentials),
            }),
        }),
        forgotPasswordSendMail: builder.mutation({
            query: (body: any) => ({
                url: `${apiRoutes.FORGOT_PASSWORD_MAIL}`,
                method: "POST",
                body,
            }),
        }),
        logout: builder.mutation({
            query: () => ({
                url: `${apiRoutes.LOGOUT}`,
                method: 'POST',
            })
        }),
        refresh: builder.mutation({
            query: (body: any) => ({
                url: `${apiRoutes.REFRESH_TOKEN}`,
                method: 'POST',
                body: body
            })
        }),
    })
});

export const {
    useLoginMutation,
    useReportsLoginMutation,
    useForgotPasswordSendMailMutation,
    useLogoutMutation,
    useRefreshMutation
} = authApiSlice;